import { components } from 'react-select';
import ColorConstants from '../../../shared/constants/ColorConstants';

export const SelectMenuList = components.MenuList;

export const SelectMenuListStyles = styles => ({
    ...styles,
    borderRadius: '6px',

    '::-webkit-scrollbar': {
        width: '5px',
    },

    '::-webkit-scrollbar-track': {
        background: 'transparent',
    },

    '::-webkit-scrollbar-thumb': {
        background: ColorConstants['pattens-blue'],
        borderRadius: '4px',
    },

    '::-webkit-scrollbar-thumb:hover': {
        background: ColorConstants['pattens-blue'],
    },
});
